// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumb-bar-two.breadcrumb-bar-two--search{overflow:visible;overflow-x:clip;z-index:2}.breadcrumb-search{position:relative;z-index:5}@media (max-width:767.98px){.breadcrumb-search{margin-top:16px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
